import React from "react";
import ContactPageHero from "../sections/ContactPageHero";
import ContactMap from "../sections/ContactMap";
import GetInTouch from "../sections/GetInTouch";
import News from "../sections/News";

const ContactPage = () => {
  return (
    <div>
      <ContactPageHero />
      <ContactMap />
      <GetInTouch />
      <News />
    </div>
  );
};

export default ContactPage;
